"use strict";
/*
 * Copyright (C) 2020 Graylog, Inc.
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the Server Side Public License, version 1,
 * as published by MongoDB, Inc.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * Server Side Public License for more details.
 *
 * You should have received a copy of the Server Side Public License
 * along with this program. If not, see
 * <http://www.mongodb.com/licensing/server-side-public-license>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var THEME_BASE_1 = require("../../THEME_BASE");
var colors_1 = require("../../utils/colors");
var generateTableColors = function (colorScheme, completeVariant) {
    if (![THEME_BASE_1.COLOR_SCHEME_DARK, THEME_BASE_1.COLOR_SCHEME_LIGHT].includes(colorScheme)) {
        throw new Error("Requires \"".concat(THEME_BASE_1.COLOR_SCHEME_DARK, "\" or \"").concat(THEME_BASE_1.COLOR_SCHEME_LIGHT, "\" color scheme option."));
    }
    var adjust = colorScheme === THEME_BASE_1.COLOR_SCHEME_DARK ? colors_1.darken : colors_1.lighten;
    return {
        background: adjust(completeVariant.default, 0.95),
        backgroundAlt: adjust(completeVariant.default, 0.85),
        backgroundHover: adjust(completeVariant.default, 0.9),
        variant: {
            danger: adjust(completeVariant.danger, 0.75),
            active: adjust(completeVariant.default, 0.75),
            info: adjust(completeVariant.info, 0.75),
            primary: adjust(completeVariant.primary, 0.75),
            success: adjust(completeVariant.success, 0.75),
            warning: adjust(completeVariant.warning, 0.75),
        },
        variantHover: {
            danger: completeVariant.lighter.danger,
            active: completeVariant.lighter.default,
            info: completeVariant.lighter.info,
            primary: completeVariant.lighter.primary,
            success: completeVariant.lighter.success,
            warning: completeVariant.lighter.warning,
        },
    };
};
exports.default = generateTableColors;
